var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageTrainers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0409 13.64L3.7909 15.06C3.75716 15.2304 3.78613 15.4072 3.8725 15.5579C3.95888 15.7086 4.09683 15.823 4.2609 15.88C5.0309 16.15 5.71089 16.4 6.69089 16.83C7.26089 17.07 7.95089 17.46 9.12089 17.95C9.52329 18.0953 9.93846 18.2024 10.3609 18.27H13.3609C13.528 18.2686 13.6927 18.2295 13.8426 18.1556C13.9925 18.0818 14.1237 17.975 14.2266 17.8433C14.3295 17.7116 14.4012 17.5583 14.4366 17.395C14.472 17.2317 14.4701 17.0625 14.4309 16.9L13.7109 13C13.7109 10.75 10.7109 10.75 9.21091 9.25C8.46091 8.5 10.7109 8.5 10.7109 4.75C10.7109 2.25 9.71091 1 7.71091 1C5.71091 1 4.71091 2.25 4.71091 4.75C4.71091 8.5 6.96091 8.5 6.21091 9.25C4.71091 10.75 1.71091 10.75 1.71091 13L1.03089 16.9C0.99174 17.0625 0.989777 17.2317 1.02515 17.395C1.06053 17.5583 1.13234 17.7116 1.23521 17.8433C1.33807 17.975 1.46934 18.0818 1.61924 18.1556C1.76914 18.2295 1.93379 18.2686 2.1009 18.27H7.02091C7.21153 18.2725 7.39887 18.2204 7.56089 18.12L8.2009 17.73",
    stroke: "#888281",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3408 13.6401L11.6708 15.3201C10.6741 15.4207 9.67247 15.4641 8.67081 15.4501C6.67081 15.4501 4.7408 15.5101 3.8208 15.4501",
    stroke: "#888281",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageTrainers);
export default __webpack_public_path__ + "static/media/manage-trainers.9ce2b7ea695757d89eae8abce625340a.svg";
export { ForwardRef as ReactComponent };